import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { editOpportunity } from 'services/api/requests/demand/opportunity/opportunity';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useEditOpportunity = (
	id: number,
	onErrorHierarchyNotFound?: VoidFunction
) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation((body: any) => editOpportunity(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['oportunidade-list'] });
			queryClient.invalidateQueries({
				queryKey: ['opportunityWithId', id],
			});
			history.goBack();
			toast({
				title: 'Atualizada com sucesso!',
				description: 'Oportunidade atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error?.status === 428 || error?.response?.status === 428) {
				if (onErrorHierarchyNotFound) {
					onErrorHierarchyNotFound();
				}
			} else {
				const toastErrors: Array<any> = mapErrorToToastProps(
					error,
					'Erro ao editar Oportunidade!'
				);
				for (const element of toastErrors) {
					toast(element);
				}
			}
		},
	});
};
